import store from '../store';

// Use the existing application's access token; Salesforce credentials stay in the API.
export function libraryFetch(url, options = {}) {
    const token = store.getState().user.token || sessionStorage.getItem('accessToken');
    if (!token) return Promise.reject(new Error('Please sign in to use the library.'));
    return fetch(url, {
        ...options,
        headers: { ...options.headers, Authorization: `Bearer ${token}` }
    });
}
